import { render, staticRenderFns } from "./CommonInput.vue?vue&type=template&id=050e8e08&scoped=true&"
import script from "./CommonInput.vue?vue&type=script&lang=js&"
export * from "./CommonInput.vue?vue&type=script&lang=js&"
import style0 from "./CommonInput.vue?vue&type=style&index=0&id=050e8e08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050e8e08",
  null
  
)

export default component.exports